<template><!-- svgo-optimised -->
<svg class="icon icon__close" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" fill="#fff" r="14.5" opacity=".85"/><path d="M20.5 20.5 10 10m0 10.5L20.5 10"/></svg>
</template>